import React from "react";
import PropTypes from "prop-types";
// Chakra imports
import { Box, Flex } from "@chakra-ui/react";

function AuthCover(props) {
  const { children, image, ...rest } = props;
  return (
    <Flex position="relative">
      <Flex
        minH={{ md: "950px" }}
        w="100%"
        maxW="1044px"
        mx="auto"
        top="0"
        justifyContent="space-between"
        mb="30px"
      >
        {children}
        <Box
          overflowX="hidden"
          h={{ base: "100%", lg: "100%" }}
          w="100%"
          top="0px"
          left="0px"
          right="0px"
          bgSize="cover"
          position="absolute"
          bgImage={image}
          backgroundRepeat="no-repeat"
          margin="0" // Remove any potential margin
          padding="0" // Remove any potential padding
        ></Box>
      </Flex>
    </Flex>
  );
}
// PROPS

AuthCover.propTypes = {
  image: PropTypes.any,
};
export default AuthCover;
